<template>
  <!-- «Обновить ЭЦП» на всех страницах. Модалка одна на приложение: профиль открывает её же
       через событие open-ecp-update — NCALayer ищет поля *_sign по id, дублей на странице быть не должно -->
  <div v-if="logged_in">
    <button type="button" class="ecp-update-btn" title="Обновить ЭЦП" @click="open">
      <i class="material-icons">vpn_key</i><span>Обновить ЭЦП</span>
    </button>
    <modal name="ecp-update-modal">
      <div class="modal-inner">
        <form method="POST" @submit.prevent="sendSignData">
          <h3>Обновление / загрузка ЭЦП</h3>
          <p>
            Для успешного обновления рекомендуется <br> выбирать ключ <b>GOSTKNCA</b>
          </p>
          <button type="button" class="profile-action-btn" @click="getKeyInfoCall">
            Выбрать сертификат
          </button>
          <br/>
          <div hidden>
            <input id="keyId_sign" name="keyId_sign"/>
            <input id="subjectDn_sign" name="subjectDn_sign"/>
            <input id="serialNumber_sign" name="serialNumber_sign"/>
            <input id="certNotAfter_sign" name="certNotAfter_sign"/>
            <input id="certNotBefore_sign" name="certNotBefore_sign"/>
            <textarea id="pem_sign" name="pem_sign" rows="7" readonly></textarea>
            <input id="alias_sign" name="alias_sign"/>
            <input id="algorithm_sign" name="algorithm_sign"/>
            <input id="subjectCn_sign" name="subjectCn_sign"/>
            <input id="issuerCn_sign" name="issuerCn_sign"/>
            <input id="issuerDn_sign" name="issuerDn_sign"/>
            <input id="authorityKeyIdentifier_sign" name="authorityKeyIdentifier_sign"/>
          </div>
          <button id="auth_sign" type="submit" hidden>submit</button>
        </form>
      </div>
    </modal>
  </div>
</template>

<script>
import {getKeyInfo} from "../nclayer/ncalayer";

export default {
  name: 'EcpUpdate',
  data() {
    return {
      logged_in: false,
    };
  },
  watch: {
    $route() {
      this.logged_in = !!localStorage.getItem('token');
    },
  },
  created() {
    this.logged_in = !!localStorage.getItem('token');
    this.$root.$on('open-ecp-update', this.open);
  },
  beforeDestroy() {
    this.$root.$off('open-ecp-update', this.open);
  },
  methods: {
    open() {
      this.$modal.show("ecp-update-modal");
    },
    getKeyInfoCall() {
      getKeyInfo("PKCS12");
    },
    sendSignData() {
      let formData = {
        keyId_sign: document.getElementById("keyId_sign").value,
        subjectDn_sign: document.getElementById("subjectDn_sign").value,
        serialNumber_sign: document.getElementById("serialNumber_sign").value,
        certNotAfter_sign: document.getElementById("certNotAfter_sign").value,
        certNotBefore_sign: document.getElementById("certNotBefore_sign").value,
        pem_sign: document.getElementById("pem_sign").value,
        alias_sign: document.getElementById("alias_sign").value,
        algorithm_sign: document.getElementById("algorithm_sign").value,
        subjectCn_sign: document.getElementById("subjectCn_sign").value,
        issuerCn_sign: document.getElementById("issuerCn_sign").value,
        issuerDn_sign: document.getElementById("issuerDn_sign").value,
        authorityKeyIdentifier_sign: document.getElementById("authorityKeyIdentifier_sign").value,
      };
      this.$store.dispatch("update_ecp_profile", formData).then((response) => {
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: "Уведомление: " + response.data.detail,
        })
        this.$router.go()
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: 'Ошибка: ' + error.response.data.detail,
        })
      });
    },
  },
};
</script>

<style scoped>
/* Кнопка в правом верхнем углу контента: правее неё на карточках акта/договора
   идёт колонка действий шириной 100px, поэтому отступ справа 110px */
.ecp-update-btn {
  position: fixed;
  top: 10px;
  right: 110px;
  z-index: 40;
  display: flex;
  align-items: center;
  gap: .3rem;
  padding: .35rem .8rem;
  border: 1px solid rgb(99 102 241);
  border-radius: 1rem;
  background: rgb(99 102 241);
  color: #fff;
  font-size: .85rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .15);
}

.ecp-update-btn:hover {
  background: #fff;
  color: rgb(99 102 241);
  transition: all .3s;
}

.ecp-update-btn .material-icons {
  font-size: 18px;
}

@media (max-width: 700px) {
  .ecp-update-btn {
    right: 16px;
  }

  .ecp-update-btn span {
    display: none;
  }
}

.profile-action-btn {
  border: 1px solid rgb(99 102 241);
  border-radius: 15px;
  padding: 1rem;
  background: rgb(99 102 241);
  color: #fff;
}

.profile-action-btn:hover {
  background: #fff;
  color: rgb(99 102 241);
  transition: all .3s;
}
</style>
